(function () {
  function shareMethod(element, url, dialogName) {
    if (!element) return;
    element.addEventListener('click', function (e) {
      e.preventDefault();
      window.open(url, dialogName + '-share-dialog', 'width=800,height=600');
    });
  }

  function printElement(element, printCssHref) {
    var iframe = document.createElement('iframe');
    iframe.style.visibility = 'hidden';
    iframe.style.position = 'fixed';
    iframe.style.right = '0';
    iframe.style.bottom = '0';
    document.body.appendChild(iframe);

    var doc = iframe.contentDocument || iframe.contentWindow.document;
    doc.open();
    doc.close();

    var link = doc.createElement('link');
    link.rel = 'stylesheet';
    link.href = printCssHref;
    doc.head.appendChild(link);
    doc.body.appendChild(doc.importNode(element, true));

    function printAndCleanup() {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
      setTimeout(function () {
        if (iframe.parentNode) {
          document.body.removeChild(iframe);
        }
      }, 100);
    }

    if (link.sheet) {
      printAndCleanup();
    } else {
      link.addEventListener('load', printAndCleanup);
      link.addEventListener('error', printAndCleanup);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    var root = document.querySelector('.article-rezepte');
    if (!root) return;

    var shareURL = encodeURIComponent(window.location.href);
    var shareText = encodeURIComponent('Check out this awesome content!');

    shareMethod(
      document.getElementById('share-facebook'),
      'https://www.facebook.com/sharer/sharer.php?u=' + shareURL,
      'facebook'
    );
    shareMethod(
      document.getElementById('share-x'),
      'https://twitter.com/intent/tweet?url=' + shareURL + '&text=' + shareText,
      'twitter'
    );
    shareMethod(
      document.getElementById('share-pinterest'),
      'https://pinterest.com/pin/create/button/?url=' + shareURL + '&description=' + shareText,
      'pinterest'
    );

    var productBtn = root.querySelector('[data-rezepte-product-url]');
    if (productBtn && productBtn.dataset.rezepteProductUrl) {
      productBtn.addEventListener('click', function () {
        window.location.href = productBtn.dataset.rezepteProductUrl;
      });
    }

    var printCssHref = root.dataset.printCss;
    var rezeptePrintBtn = document.getElementById('rezepte-print-btn');
    if (rezeptePrintBtn && printCssHref) {
      rezeptePrintBtn.addEventListener('click', function () {
        var printTarget = document.getElementById('print-rezepte');
        if (!printTarget) return;

        if (window.innerWidth < 769) {
          window.print();
        } else {
          printElement(printTarget, printCssHref);
        }
      });
    }
  });
})();
